<template>
  <v-row>
    <v-col cols="12" class="pt-0 pb-4">
      <Title title="Данные исходной образовательной организации" font-size="15" text-start/>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.specialityFrom"
        :items="dictionaries.speciality"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Специальность</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.courseNumberFrom"
        :items="dictionaries.courseNumber"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Номер курса</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.submissionSession"
        :items="isActualSubmissionSession"
        item-text="semester.name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Семестр</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-show="!showOrganizationNameFrom"
        v-model="application.organizationFrom"
        :items="dictionaries.organization"
        item-text="name"
        clearable outlined rounded dense return-object
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        hint="Если вы не нашли название университета в выпадающем списке, введите название вручную, нажав на карандаш"
        append-outer-icon="mdi-pencil-outline"
        @click:append-outer="changeShowOrganizationNameFrom"
        @input="setApplication"
      >
        <template #label>
          <span class="required">Наименование образовательной организации</span>
        </template>
      </v-autocomplete>

      <v-text-field
        v-show="showOrganizationNameFrom"
        v-model="application.organizationNameFrom"
        placeholder="Введите данные"
        rounded outlined dense
        append-outer-icon="mdi-pencil-outline"
        @click:append-outer="changeShowOrganizationNameFrom"
        @input="setApplication"
      >
        <template #label>
          <span class="required">Наименование образовательной организации</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-autocomplete
        v-model="application.paidFormTo"
        :items="dictionaries.paidForm"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Тип обучения</span>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>

import {Application} from '@/models'
import Title from "@/components/ui/Title";
import DatePicker from "@/components/ui/DatePicker"
import {mapGetters} from "vuex"

export default {
  name: 'ApplicationOrganizationTransfer',

  components: {
    Title,
    DatePicker
  },

  props: {
    dialog: Boolean,
    item: Application
  },

  data() {
    return {
      application: new Application(),

      showOrganizationNameFrom: false,
    }
  },

  validations() {
    return {
      application: {
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries', 'isActualSubmissionSession']),
  },

  methods: {
    changeShowOrganizationNameFrom() {
      this.showOrganizationNameFrom = !this.showOrganizationNameFrom

      this.showOrganizationNameFrom ? this.application.organizationFrom = null
                                    : this.application.organizationNameFrom = null
    },

    setApplication() {
      this.$emit('set-data', this.application)
    },

    async setExpirationDate(value) {
      this.application.expirationDate = value
      await this.saveApplication()
    },
  },

  watch: {
    'item.id': {
      immediate: true,
      handler() {
        this.application = Application.build(this.item)

        if (!this.application.organizationFrom?.id && this.application.organizationNameFrom) {
          this.showOrganizationNameFrom = true
        }
      }
    }
  }
}
</script>
<style scoped>
</style>
